/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Admin resource route shells, two-panel item layout, and
 * activate/archive/delete chrome.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';

import {AppSharedModule} from '../app-shared.module';
import {ObjectStatesModule} from '../directives/object-states.module';
import {AdminResourceContextRoutePageComponent} from './admin-resource-context-route-page.component';
import {AdminResourceEditRoutePageComponent} from './admin-resource-edit-route-page.component';
import {AdminResourceItemRoutePageComponent} from './admin-resource-item-route-page.component';
import {ResourceListRoutePageComponent} from './resource-list-route-page.component';
import {AdminResourceContextActionsComponent} from '../directives/admin-resource-context-actions.component';
import {AdminResourceDeleteComponent} from '../directives/admin-resource-delete.component';
import {SpecifyIdModalComponent} from '../directives/specify-id-modal.component';
import {TwoPanelLayoutComponent} from '../directives/two-panel-layout.component';

const ADMIN_RESOURCE_PAGES = [
  AdminResourceContextRoutePageComponent,
  AdminResourceEditRoutePageComponent,
  AdminResourceItemRoutePageComponent,
  ResourceListRoutePageComponent,
  AdminResourceContextActionsComponent,
  AdminResourceDeleteComponent,
  SpecifyIdModalComponent,
  TwoPanelLayoutComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ObjectStatesModule
  ],
  declarations: ADMIN_RESOURCE_PAGES,
  exports: ADMIN_RESOURCE_PAGES
})
export class AdminResourcePagesModule {
}
